import { useEffect, useState } from "react"
import { TablaVentasArticulo } from "../../Huespedes.type"

// Maneja la fila seleccionada de la tabla del reporte para mostrarla en el sidebar de detalle.
// La fila seleccionada no se limpia al cerrar para que el contenido no desaparezca
// mientras corre la animación de salida del drawer.
const useHuespedesDetail = (rows?: TablaVentasArticulo[]) => {
    const [selectedRow, setSelectedRow] = useState<TablaVentasArticulo | null>(null)
    const [isOpen, setIsOpen] = useState(false)

    // rowKey es el índice de la fila dentro de la página actual, lo envía la tabla en su evento goTo
    const openDetail = (rowKey: string) => {
        const index = Number(rowKey)
        if (!rowKey || Number.isNaN(index)) {
            return
        }
        const row = rows?.[index]
        if (!row) {
            return
        }
        setSelectedRow(row)
        setIsOpen(true)
    }

    const closeDetail = () => setIsOpen(false)

    // Al cambiar los registros (página, filtros, orden o rango de fechas) el detalle abierto ya no corresponde
    useEffect(() => {
        setIsOpen(false)
    }, [rows])

    return {
        selectedRow,
        isOpen,
        openDetail,
        closeDetail,
    }
}

export default useHuespedesDetail
